<template>
  <div>
    <a-spin :spinning="questionLoading">
      <div v-if="questionData || true">
        <a-form class="mb-4" :form="form">
          <div class="row">
            <!-- Question -->
            <div class="col-12 mb-2">
              <a-form-item label="Question" required>
                <div style="line-height: 1;">
                  <neo-ckeditor :initialValue="question" @change="handleQuestionEditorChange" v-validate="'required'"></neo-ckeditor>
                </div>
              </a-form-item>
            </div>
            <!-- Description -->
            <div class="col-12 mb-2">
              <a-form-item label="Description">
                <a-textarea placeholder="Description" :autosize="{minRows: 1}" v-decorator="['description', {rules: [{max: 200, message: 'Must not exceed 200 characters!'}]}]" />
              </a-form-item>
            </div>
            <!-- Instruction -->
            <div class="col-12 mb-2">
              <a-form-item label="Instruction">
                <a-textarea placeholder="Instruction" :autosize="{minRows: 1}" v-decorator="['instruction', {rules: [{max: 200, message: 'Must not exceed 200 characters!'}]}]" />
              </a-form-item>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <p v-if="form.getFieldValue('is_entry')" class="font-weight-bold text-muted">Correct Answer</p>
            <p v-else class="font-weight-bold text-muted">Question Options</p>
            <a href="javascript:;" class="btn btn-primary btn-with-addon"
              v-if="!form.getFieldValue('is_entry')"
              @click="handleAddOption"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-plus" />
              </span>
              Add option
            </a>
          </div>

          <template v-if="options">
            <div class="row" v-for="(option, index) in options" :key="option.id">
              <div class="col-md-10 mb-2">
                <!-- <a-form-item required> -->
                <a-form-item :label='getOption(index)' required>
                  <neo-ckeditor :editorId="option.id" :initialValue="option.value" @change="handleEditorChange"></neo-ckeditor>
                </a-form-item>
              </div>
              <div class="col-md-2 mb-2" style="margin-top:10px">
                <!-- Mark -->
                <!-- <a-form-item label="Mark">
                  <a-input-number
                    v-model="option.mark"
                    :default="0"
                    :min="-100"
                    :max="100"
                    placeholder="mark"
                    style="width:100%;"
                  />
                </a-form-item> -->
                <!-- Correct -->
                <a-form-item>
                  <a-checkbox
                    v-model="option.correct"
                    :disabled="form.getFieldValue('is_entry') === 1"
                  >
                    Correct
                  </a-checkbox>
                </a-form-item>
                <div v-if="index > 0">
                  <a href="javascript:;" class="btn btn-danger"
                    @click="handleRemoveOption(option.id)"
                  >
                    <span class="btn-addon">
                      <i class="btn-addon-icon fe fe-trash" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </a-form>
      </div>
    </a-spin>
  </div>
</template>

<script>
import NeoCkeditor from '@/components/ckeditor'
import { makeQuestionEditData, makeOptionData } from './fields'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'QuestionForm',
  components: {
    NeoCkeditor,
  },
  props: ['formId', 'questionId', 'onlineExamData', 'questionLoading', 'questionData', 'isEntry'],
  mounted: function () {
    if (this.questionId) {
      this.getQuestionData()
    }
  },
  created() {
    this.handleFormUpdate = debounce(this.handleFormUpdate, 700)
  },
  watch: {
    questionId: function(value) {
      this.form.resetFields()
      this.options = this.defaultOptions
      this.question = ''
      if (value) {
        this.getQuestionData()
      }
    },
    isEntry: function(value) {
      if (value === 1) {
        this.options = [
          { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 1, mark: this.form.getFieldValue('mark'), correct: true },
        ]
      } else {
        this.options = this.defaultOptions
      }
    },
    options: {
      handler(value) {
        this.handleFormUpdate()
      },
      deep: true,
    },
    question: function(value) {
      this.handleFormUpdate()
    },
  },

  data: function() {
    return {
      form: this.$form.createForm(this, { onValuesChange: debounce(this.handleFormUpdate, 700) }),
      loading: false,
      visible: false,
      spinning: false,
      subjectSpinning: false,
      subjects: [],
      question: '',
      editQuestion: null,
      defaultOptions: [
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
      ],
      options: [
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
        { id: this._uid + Math.floor(Math.random() * 10000), value: '', is_entry: 0, mark: 0, correct: false },
      ],
      orQuestions: [],
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    getOption(i) {
      var serial = i + 1
      return 'Option-' + serial
    },
    handleFormUpdate(props, values) {
      this.form.validateFields((err, values) => {
        let qData = this.makeQuestionFormData(values)
        this.$emit('updated', {
          id: this.formId,
          questionData: qData,
          err,
        })
      })
    },
    handleEditorChange({ value, editorId }) {
      this.option = this.options.map(function(option) {
        if (option.id === editorId) {
          option.value = value
        }
        return option
      })
    },
    handleQuestionEditorChange({ value }) {
      this.question = value
    },
    handleAddOption: function() {
      let editorId = this._uid + Math.floor(Math.random() * 10000)
      this.options.push({
        id: editorId,
        value: '',
        is_entry: 0,
        mark: 0,
        correct: false,
      })
    },
    handleCorrectChecked: function(optionId) {
      this.options = this.options.map(function(option) {
        if (option.id !== optionId) {
          option.correct = false
        }
        return option
      })
    },
    handleRemoveOption: function(optionId) {
      this.options = this.options.filter(function(option) {
        return option.id !== optionId
      })
    },
    getQuestionData: function() {
      this.editQuestion = this.questionData
      let editQuestionData = makeQuestionEditData(this.editQuestion)
      if (this.editQuestion !== null) {
        this.question = this.editQuestion.question
      }
      this.options = makeOptionData(this._uid, this.editQuestion)
      this.form.setFieldsValue(editQuestionData)
    },

    makeQuestionFormData: function (values) {
      return {
        question: this.question,
        description: values.description,
        instruction: values.instruction,
        options: this.options.map(function(option) {
          return {
            value: option.value,
            is_entry: option.is_entry,
            mark: option.mark,
            correct: option.correct,
          }
        }),
      }
    },
  },
}
</script>
